<div class="container-custom">
  <h2 class="title title-greetins">{{ saludo }}</h2>
  <div class="container-grid">
    <div class="menu-boat" [ngClass]="{'active': general}" (click)="typeBoat(0)">
      <figure>
        <i class="bi bi-file-text"></i>
      </figure>
      <div>
        <p>Listado de Barcos</p>
        <span>General</span>
      </div>
    </div>
    <div class="menu-boat" [ngClass]="{'active': importacion}" (click)="typeBoat(1)">
      <figure>
        <i class="bi bi-file-text"></i>
      </figure>
      <p>Importación</p>
    </div>
    <div class="menu-boat" [ngClass]="{'active': exportacion}" (click)="typeBoat(2)">
      <figure>
        <i class="bi bi-file-text"></i>
      </figure>
      <p>Exportación</p>
    </div>
    <div class="menu-boat" [ngClass]="{'active': cabotajeImp}" (click)="typeBoat(4)">
      <figure>
        <i class="bi bi-file-text"></i>
      </figure>
      <p>Cabotaje Imp</p>
    </div>
    <div class="menu-boat" [ngClass]="{'active': cabotajeExp}" (click)="typeBoat(3)">
      <figure>
        <i class="bi bi-file-text"></i>
      </figure>
      <p>Cabotaje Exp</p>
    </div>
  </div>
  <div class="d-flex">
    <h2 class="title">{{ titulo }} |</h2>
    <label for="typeBoat" class="form-label" class="filter_year" *ngIf="!blLoader">Tipo:</label>
    <select
      name="typeBoat"
      id="typeBoat"
      class="form-control"
      (change)="changeType()"
      [formControl]="type"
      *ngIf="!blLoader"
    >
      <option [ngValue]="0">General</option>
      <option [ngValue]="1">Importación</option>
      <option [ngValue]="2">Exportación</option>
      <option [ngValue]="4">Cabotaje Imp</option>
      <option [ngValue]="3">Cabotaje Exp</option>
    </select>
    <h2 class="limit type-limit">|</h2>
    <label for="year" class="form-label" class="filter_year" *ngIf="!blLoader">Año:</label>
    <select
      name="year"
      id="year"
      class="form-control"
      (change)="changeYear()"
      [formControl]="year"
      *ngIf="!blLoader"
    >
      <option *ngFor="let year of yearsList" [value]="year">{{ year }}</option>
    </select>
    <h2 class="limit">|</h2>
    <label for="shipType" class="form-label" class="filter_year" *ngIf="!blLoader">Barcos:</label>
    <select
      name="shipType"
      id="shipType"
      class="form-control"
      [formControl]="shipType"
      *ngIf="!blLoader"
    >
      <option value="Todos">Todos</option>
      <option value="Activos">Activos</option>
      <option value="No activos">No activos</option>
    </select>
  </div>
  <div class="error" *ngIf="shipError">Error de comunicación con el sistema de muelles.</div>
  <app-table
    [table_config]="table_config"
    [array]="blsArray"
    [loader]="blLoader"
  ></app-table>
</div>
<app-overlay
*ngIf="overlayError || overlayErrorShips"
[reload]="true"
></app-overlay>
<app-overlay
  *ngIf="overlay"
  [mensaje]="message"
  [icono]="icon"
></app-overlay>
